module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/reggio-calabria.7d187683806419d758571a0ed17d734a.jpg";